import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// guards
import AuthGuard from './AuthGuard';

// ----------------------------------------------------------------------

AdminGuard.propTypes = {
  children: PropTypes.node,
};

// Client-side gate only — every /api/admin route is independently protected by hasAdminRole
// on the server. Non-admins are bounced to their normal dashboard rather than shown a wall.
export default function AdminGuard({ children }) {
  const { user } = useAuth();

  return (
    <AuthGuard>
      {user?.role === 'admin' ? children : <Navigate to="/dashboard" replace />}
    </AuthGuard>
  );
}
